export default __webpack_public_path__ + "static/media/birdpic.363fbdd6.png";